/*
 * @description: 
 * @author: Jason Wong
 * @since: 2021-01-28 10:25:30
 */
/*
 * @author: Jason Wong
 * @desc: pool of paths
 */

export default {
  downloadPrefix: "/saipan",
  baseUrl: "/saipan/home/",
  resourceBaseUrl: "/saipan/home/",
  prefixUrl: "", //路由前缀
};
